import React, {Component} from "react";
import { connect } from "react-redux";
import firebase from "firebase";
import moment from "moment";
import {database,storage,authentication } from "../../app-database";
import DetalleAutorizadorDbk from './detalleAutorizadorDbk.cmpt';
import { getPolizaInfo,getCorreoCU,updateStatusKm,updateStatusNuevo } from "../../movil/polizas/pagoPorKilometro.act";

const anios=[];
const anioActual = new Date().getFullYear()+1;
const anioInicio = 2010;




for(let i = anioInicio;i<anioActual;i++){
	anios.push(i);
}

const mapState = (state) => {
	return {
		resulta: state.config,
		dispositivo: state.global.dispositivo,
		detalleAutorizador: state.registroDbk.detalleAutorizador
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({"type": "LOADER", "show": show});
		},
		setDetalleAutorizador: (data,styleExitoso) => {
			dispatch({
				type: 'SET_DETAIL_DBK',
				detalleAutorizador: data,
				styleExitoso:styleExitoso
			});

		},		
		// tagManager: (oDataTagManager) => {
		// 	dispatch(oDataTagManager);
		// }
	};
};
const tagManager = (oDataTagManager) =>{
	debugger
	window.dataLayer = window.dataLayer || [];
	
	window.dataLayer.push({
		event: oDataTagManager.type,
		payload: oDataTagManager
	});	
};



class AutorizadorDBK0 extends Component{
	constructor(props){
		super(props);
		this.noHided = 0;
		this.state={
			show:false,
			buscar: "",
			version: 0,
			tab: "tabConfiguracion",						
			result:"",
			config: "",
			classBtn: "orange-rectangle",
			paginas: [],
			currentPage: 0,
			currentMetaPage: 0,
			polizaAu:"",
			filterWord: ""
		};
	}

	setFilter(event){
		this.noHided = 0;
		this.setState({filterWord: event.target.value.substring(0,9),
					   currentPage: 0
					  });
		return 0;
	}

	showRow(state,i,poliza){
		var nowDate = moment();
		var regDate= moment(state.config[i].fechaCaptura.substring(0,10),"DD-MM-YYYY");
		var diffBetwDates =	nowDate.diff(regDate,'days');

		var rangePage = (6*state.currentPage <= this.noHided && this.noHided < (6*(state.currentPage + 1) - 1));
		console.log(rangePage);

		if(((typeof(poliza.banDescuento) == 'undefined') || poliza.banDescuento < 1 )
			 && (diffBetwDates < 6 && (state.config[i].numIntento >= 0 || typeof(state.config[i].numIntento) == 'undefined' ) ) /*Filtrar segun demanda DMND0029929*/
			 && (this.state.filterWord == "" ||  state.config[i].numCliente.includes(this.state.filterWord)  
				   || state.config[i].poliza.includes(this.state.filterWord) /*Buscar segun demanda  DMND0029929 */
				   || state.config[i].fechaCaptura.includes(this.state.filterWord) )){
	
			this.noHided += 1;

			if(rangePage){  /*Para reensamblado de paginas*/
				console.log(this.noHided);
				return true;
			}else{
				return false;
			}
		}
		
		return false;
	}


	render(){
		const {config,show} = this.state;
		return (
			<div class="container">
				<h1 style={{marginLeft:10}}>AutorizadorDBK 0</h1>
				<br/>
				{!show && <div className="aceptar-cancelar-btn"><a className="orange-btn" onClick={this.login.bind(this)}>Modificar</a></div>}
				{show &&(
					<div>
						<div className="blue-wrap text-center">						
							<div className="container">
								<ul className="blue-menu clearfix">
								</ul>
							</div>
						</div>
							<div>
							<div className="input-wrap no-margin-search">
							<label>Busqueda por No.Cliente / Póliza: </label>
								<span className="clearfix input-active">
									<input type="text" value={this.state.filterWord} className="col-xs-1" multiple style={{height:"100%"}} onChange={this.setFilter.bind(this)}/>
								</span>
							</div>
								<div className="card" style={{maxWidth:550, margin: "0 auto"}}>
									<div className="input-wrap no-margin">
										<table className="table table-striped table-center mt-34 tabla-facturas" style={{marginLeft: "-20px", marginTop:"10px"}}>
											<thead>
												<tr>
													<th className="text-center">No. Cliente</th>
													<th className="text-center">Póliza</th>
													<th className="text-center">Fecha registro</th>
													<th className="text-center">No. Intentos</th>
													<th className="text-center">Ban dcto kilometraje</th>
													<th></th>
												</tr>
											</thead>

											<tbody>
												{ this.state.config && this.state.config.map((poliza, i)=>
													//<tr key={i} className='show-tr' >
													//<tr key={i} className={Math.floor(i / 6) == this.state.currentPage ? "show-tr" : "hide"}></tr>
													<tr key={i} className={this.showRow(this.state,i,poliza) ? "show-tr" : "hide"}>
														<td>{poliza.numCliente}</td>
														<td>{poliza.poliza}</td>
														<td>{poliza.fechaCaptura}</td>
														<td>{poliza.numIntento}</td>
														<td>{poliza.banDescuento}</td>
														<td><button ref="boton"  name="visualizar" onClick={this.visualizar.bind(this, poliza)} data-toggle="modal" data-target="#modal-dbkilometro" className="orange-rectangle" style={{"margin":"0px auto 0px auto","width":"80px","padding":"4px 4px"}}> Ver detalle</button></td>
											
													</tr>
												)}
											</tbody>
										</table>
										{}
										<div className="text-center paginador mt-50">
											<ul className="clearfix">
												<li className={this.state.currentPage > 6 ? "show-li" : "hide"}>
													<a onClick={this.changeMeta.bind(this, -1)}>
														<img src={ require("../../img/flecha-izquierda.svg") } />
													</a>
												</li>
												{ this.calcularPaginas().map((item, i) =>
													<li key={i} className={Math.floor(i / 6) == this.state.currentMetaPage}>
														<a className={this.state.currentPage == i ? "orange-bold-text" : "orange-text"} onClick={this.goToPage.bind(this, i)}>{i + 1}</a>
													</li>
												)}
												<li className={this.calcularPaginas() > 6 ? "show-li" : "hide"}>
													<a onClick={this.changeMeta.bind(this, 1)}>
														<img src={ require("../../img/flecha-abajo.svg") } />
													</a>
												</li>
											</ul>
										</div>
									<div className="modal fade modal-msj" id="modal-dbkilometro" tabIndex="-1" role="dialog" aria-labelledby="modal-dbkilometro" data-backdrop="static" data-keyboard="false">
										<div className="modal-dialog" role="document">
											<div className="modal-content" style={{ overflow: "hidden" }}>
												<DetalleAutorizadorDbk />
												<div className="modal fade modal-msj" id="modal-confirmacionDBK" tabIndex="-1" role="dialog" aria-labelledby="modal-msj-exitoso" data-backdrop="static" data-keyboard="false">
													<div className="modal-dialog" role="document">
														<div className="modal-content" style={{ overflow: "hidden" }} >
															<h5 className="text-center" style={{ marginBottom: "44px" }}>Registro Exitoso</h5>
															<div className="text-center aceptar-cancelar-btn mt-75">
																<a onClick={this.SendRegistroExiCan.bind(this,1)} className="orange-btn">Aceptar</a>
																<a onClick={this.volver.bind(this)} className="orange-btn">Cancelar</a>
															</div>
														</div>
													</div>
												</div>
												<div className="modal fade modal-msj" id="modal-confirmacionRN" tabIndex="-1" role="dialog" aria-labelledby="modal-msj-nuevo" data-backdrop="static" data-keyboard="false">
													<div className="modal-dialog" role="document">
														<div className="modal-content" style={{ overflow: "hidden" }} >
															<h5 className="text-center" style={{ marginBottom: "44px" }}>Registrar Nuevamente</h5>
															<div className="text-center aceptar-cancelar-btn mt-75">
																<a onClick={this.SendNuevoRegistro.bind(this)} className="orange-btn">Aceptar</a>
																<a onClick={this.volver.bind(this)} className="orange-btn">Cancelar</a>
															</div>
														</div>
													</div>
												</div>
												<div className="modal fade modal-msj" id="modal-confirmacionRechazo" tabIndex="-1" role="dialog" aria-labelledby="modal-msj-rechazo" data-backdrop="static" data-keyboard="false">
													<div className="modal-dialog" role="document">
														<div className="modal-content" style={{ overflow: "hidden" }} >
															<h5 className="text-center" style={{ marginBottom: "44px" }}>Registro Cancelado</h5>
															<div className="text-center aceptar-cancelar-btn mt-75">
																<a onClick={this.SendRegistroExiCan.bind(this,2)} className="orange-btn">Aceptar</a>
																<a onClick={this.volver.bind(this)} className="orange-btn">Cancelar</a>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
										
										
									</div>
								</div>
							</div>
							
					</div>
										
				)}
			</div>);
	}

	

	calcularPaginas = () => {
		var numPaginas = 0;

		if (this.state.config) {
			numPaginas = Math.ceil((this.noHided) / 6);
		}

		var paginas = [];
		for (var i = 0; i < numPaginas; i++) {
			paginas.push("");
		}
		return paginas;
	}
	
	goToPage = (i) => {
		this.noHided= 0
		this.setState({
			"currentPage": i
		});
	}

	changeMeta = (change) => {
		var currentMetaPage = this.state.currentMetaPage + change;
		this.setState({
			"currentMetaPage": currentMetaPage
			
		});
	}

	visualizar=(poliza)=>{
		this.noHided= 0
		this.props.setDetalleAutorizador(poliza,poliza.styleCompleto);
		if(typeOf(this.state) !== "undefined"){
		this.setState({
			"currentPage": this.state.currentPage
		});
	}
	}

	
  SendRegistroExiCan=(tipo)=>{
		$('#modal-confirmacionDBK').modal('hide');
		$('#modal-confirmacionRechazo').modal('hide');
		var numCliente = this.props.detalleAutorizador.numCliente;
		var poliza = this.props.detalleAutorizador.poliza;
		var detalleAutorizador=this.props.detalleAutorizador;
		var km=this.props.detalleAutorizador.km;
		getCorreoCU(numCliente)
			.then((result)=> {
				this.props.loader(true);
				var img=result.registroCompleto;
				var subject="¡Registro exitoso! Distintivo bajo kilometraje GNP";
				if (tipo===2){
					img=result.registroCancelado;
					subject="Aviso Distintivo bajo kilometraje GNP";
				}
				var datos={
					poliza:poliza,
					mail:result.mail,
					img:img,
					subject:subject,
					ban_descuento:tipo,
					km:km
				}
				if (result.mail!==null){
					updateStatusKm(datos)
						.then((result)=> {
							detalleAutorizador.banDescuento=tipo;
							detalleAutorizador.styleCompleto=false;
							detalleAutorizador.styleNuevo=false;
							detalleAutorizador.styleCancelado=false;
							if (tipo===2){
								detalleAutorizador.supIzq = null;
								detalleAutorizador.supDer = null;
								detalleAutorizador.infIzq = null; 
								detalleAutorizador.infDer = null; 
								detalleAutorizador.vin = null; 
								detalleAutorizador.ini = null;
								detalleAutorizador.km="";
							}
							this.props.setDetalleAutorizador(detalleAutorizador,true);
							$('#modal-dbkilometro').modal("hide");
							tagManager({
								dispositivo: "web",
								type: 'EVENT_CLICK_REGISTRO_AUTORIZADOR-PAGO-POR-KM'
							});
							this.props.loader(false);
							this.setState({
								result
							});
						});
				}				

			});	
	}	
	SendNuevoRegistro(){
		$('#modal-confirmacionRN').modal('hide');
		var numCliente = this.props.detalleAutorizador.numCliente;
		var poliza = this.props.detalleAutorizador.poliza;
		var detalleAutorizador=this.props.detalleAutorizador;
		getCorreoCU(numCliente)
			.then((result)=> {
				this.props.loader(true);
				let date = new Date();
				let dia = (date.getDate() < 10)? "0"+date.getDate() : date.getDate();
				let mes = (date.getMonth()+1 < 10)? "0"+(date.getMonth()+1) : date.getMonth()+1;
				let anio = date.getFullYear();
				let fechaHoy=dia+"/"+mes+"/"+anio;
				console.log("fecha hoy: "+fechaHoy);
				var datos={
					poliza:poliza,
					mail:result.mail,
					img:result.registroNuevo,
					subject:"Finaliza tu registro al Distintivo bajo kilometraje GNP",
					numIntento:2,
					fechaReintento:fechaHoy
				}
				if (result.mail!==null){
					updateStatusNuevo(datos)
					.then((result)=> {
						detalleAutorizador.numIntento=2;
						detalleAutorizador.styleCompleto=false;
						detalleAutorizador.styleNuevo=false;
						detalleAutorizador.styleCancelado=false;
						detalleAutorizador.supIzq = null;
						detalleAutorizador.supDer = null;
						detalleAutorizador.infIzq = null; 
						detalleAutorizador.infDer = null; 
						detalleAutorizador.vin = null; 
						detalleAutorizador.ini = null;
						detalleAutorizador.km="";
						detalleAutorizador.fechaReintento=fechaHoy;
						this.props.setDetalleAutorizador(detalleAutorizador,false);
						$('#modal-dbkilometro').modal("hide");
						this.props.loader(false);
						this.setState({
							result
						});
					});
				}
				

			});	
		}		
	volver(){
		$('#modal-confirmacionDBK').modal('hide');
		$('#modal-confirmacionRN').modal('hide');
		$('#modal-confirmacionRechazo').modal('hide');
		
    }
	
	login() {
		var provider = new firebase.auth.GoogleAuthProvider();
		authentication.signInWithPopup(provider).then((result)=> {
			getPolizaInfo()
			.then((resultado)=> {		
				resultado.sort(function(a,b) {
					let dateA=moment(a.fechaCaptura, "DD/MM/YYYY H:mm:ss");
					let dateB=moment(b.fechaCaptura, "DD/MM/YYYY H:mm:ss");
  
					if (dateA > dateB && (!a.banDescuento && b.banDescuento)) return -1;
					if (dateA > dateB && (!a.banDescuento && !b.banDescuento)) return -1;
					if (dateA > dateB && (a.banDescuento && b.banDescuento)) return -1;
					if (dateA > dateB && (a.banDescuento && !b.banDescuento)) return 1;
					//------
					if (dateA < dateB && (!b.banDescuento && a.banDescuento)) return 1;
					if (dateA < dateB && (!b.banDescuento && !a.banDescuento)) return 1;
					if (dateA < dateB && (b.banDescuento && a.banDescuento)) return 1;	
					if (dateA < dateB && (b.banDescuento && !a.banDescuento)) return -1;
					//------
					if (dateA === dateB && (b.banDescuento && !a.banDescuento)) return -1;
					if (dateA === dateB && (!b.banDescuento && a.banDescuento)) return 1;

					return 0;
				});		
				this.setState({
					config:resultado,
					show: true
				});
			});

		});
	}
}

export default connect(mapState, mapDispatch)(AutorizadorDBK0);


// WEBPACK FOOTER //
// ./src/autorizadorDBK/km0/autorizadorDBK0.cmpt.js